// @ts-nocheck
import { deviceLocationStatusWithoutKey } from "constants/constants";
// import { VALIDATION } from "constants/messages";
import * as Yup from "yup";
const maxCapacityRegExp = /^[0-9a-zA-Z .]+$/;
export const MachineDetailsSchema = Yup.object().shape({
  inspection_datetime: Yup.string().required().label("Inspection Date"),
  inspection_type: Yup.string().required().label("Inspection Type"),
  job_location: Yup.string()
    .required()
    .min(1, "Minimum 1 character required.")
    .max(255, "You have extended maximum limit")
    .label("Job Location")
    .typeError("Job Location is required."),
  criteria: Yup.string().required().trim().label("Inspection Criteria"),
  make: Yup.string()
    .required()
    .min(1, "Minimum 1 character required.")
    .max(255, "You have extended maximum limit")
    .label("Make"),
  device_id: Yup.string()
    .nullable(true)
    .trim()
    .min(1, "Minimum 1 character required.")
    .max(255, "You have extended maximum limit")
    .label("Device ID"),
  model_number: Yup.string()
    .required()
    .min(1, "Minimum 1 character required.")
    .max(255, "You have extended maximum limit")
    .label("Model Number"),
  serial_number: Yup.string()
    .required()
    .min(1, "Minimum 1 character required.")
    .max(255, "You have extended maximum limit")
    .label("Serial Number"),
  equipment_type: Yup.object().required().label("Equipment Type"),
  equipment_category: Yup.string().required().label("Inspection Category"),
  device_location_status: Yup.string()
    .required()
    .label("Device Location Status"),

  max_capacity: Yup.string()
    .required()
    .label("Max Capacity")
    .min(1, "Minimum 1 character required.")
    .max(50, "You have extended maximum limit"),
  // .typeError(VALIDATION.maxCapacityAlphanumeric)
  // .matches(maxCapacityRegExp, VALIDATION.maxCapacityAlphanumeric),
  worksite_change: Yup.string().required().label("Worksite Change"),
  hours: Yup.number("Hours must be type of number.")
    // .required()
    .label("Hours")
    .typeError("Hours must be type of number."),
  machine_length: Yup.string(),
  // .required().label("Machine Length"),
  service_status_time_of_survey: Yup.string()
    .required()
    .label("Service Status"),
  is_quadranial: Yup.string().when("inspection_type", {
    is: (value) => value === "maritime",
    then: Yup.string()
      .required()
      .label("Quadranial")
      .typeError("Quadranial is required."),
    otherwise: Yup.string().nullable(),
  }),
  type_of_barge_work: Yup.string().when("device_location_status", {
    is: (value) => value === deviceLocationStatusWithoutKey.onbarge,
    then: Yup.string()
      .required()
      .label("Type of barge work")
      .typeError("Type of barge work is required."),
    otherwise: Yup.string().nullable(),
  }),

  // other_details: Yup.string().when("service_status_time_of_survey", {
  //   is: (value) => {
  //     debugger
  //     return value === "other";
  //   },
  //   then: Yup.string().required("Other is required"),
  // }),
  construction_details: Yup.object().required().label("Construction Details"),
  inspection_sheet: Yup.object().required().label("Inspection Sheet"),
});
